import IHQImage from "@/models/IHQImage";
import RESTApiEndPoints from "./rest-api-end-points";
import IShipAreaFinding from "../models/ship-finding";
import ShipAreaFindingArgs from "./ShipAreaFindingArgs";
import axiosService from "@/services/axios-service";
import ISearchRequest from "@/models/SearchRequest";
import IShipAreaFindingsLog from "@/models/IShipAreaFindingsLog";
import { ISyncFindingArgs, ISyncFindingData } from "@/models/msca/sync-finding-data";

export default class ShipAreaFindingsService {
  public async syncData(args: ISyncFindingArgs) {
    return (
      await axiosService.post<ISyncFindingData>(
        `${RESTApiEndPoints.shipAreaFindingsUrl()}/Sync`,
        args
      )
    )?.data;
  }

  public async add(obj: IShipAreaFinding) {
    return (await axiosService.post<IShipAreaFinding>(RESTApiEndPoints.shipAreaFindingsUrl(), obj))
      ?.data;
  }

  public async getHqImage(attachmentId: string) {
    return (
      await axiosService.get<IHQImage>(
        `${RESTApiEndPoints.shipAreaFindingsUrl()}/HQImage/${attachmentId}`
      )
    )?.data;
  }

  public async delete(id: string) {
    await axiosService.delete(`${RESTApiEndPoints.shipAreaFindingsUrl()}/${id}`);
    return;
  }

  public async update(obj: IShipAreaFinding) {
    return (
      await axiosService.put<IShipAreaFinding>(
        `${RESTApiEndPoints.shipAreaFindingsUrl()}/${obj.id}`,
        obj
      )
    )?.data;
  }

  public async updateSatisfactory(findingsId: string[], value: boolean) {
    return (
      await axiosService.post<IShipAreaFinding[]>(
        `${RESTApiEndPoints.shipAreaFindingsUrl()}/${
          value ? "issatisfactory" : "isnotsatisfactory"
        }/`,
        findingsId
      )
    )?.data;
  }

  public async getReportChart(searchRequest: ISearchRequest): Promise<IShipAreaFindingsLog[]> {
    const result = await axiosService.post<IShipAreaFindingsLog[]>(
      `${RESTApiEndPoints.shipAreaFindingsUrl()}/GetChart/`,
      searchRequest
    );
    return result.data;
  }

  public async getAll(CompartmentAssessmentId: string) {
    const response = await axiosService.get<IShipAreaFinding[]>(
      `${RESTApiEndPoints.shipAreaFindingsUrl()}/GetAll/${CompartmentAssessmentId}`
    );
    return response.data ?? [];
  }

  public async search(args: ShipAreaFindingArgs) {
    let url =
      `${RESTApiEndPoints.shipAreaFindingsUrl()}?compartmentAssessmentId=${
        args.compartmentAssessmentId
      }` +
      `&conditionAssessmentId=${args.conditionAssessmentId}` +
      `&shipAreaId=${args.shipAreasId}`;
    ///
    if (args.machineryCompartmentsId) {
      url = url + `&machineryCompartmentsId=${args.machineryCompartmentsId}`;
    }
    ///
    const response = await axiosService.get<IShipAreaFinding[]>(url);
    return response.data;
  }
}
